/**
 * Mega Menu Functionality
 * 处理宽屏下拉菜单的交互
 */

class MegaMenu {
  constructor() {
    this.triggers = document.querySelectorAll('[data-mega-menu-trigger]');
    this.activeMenu = null;
    this.closeTimeout = null;
    this.init();
  }

  init() {
    if (this.triggers.length === 0) return;

    this.triggers.forEach(trigger => {
      const menuId = trigger.getAttribute('aria-controls');
      const menu = document.getElementById(menuId);

      if (!menu) return;

      // 鼠标悬停打开
      trigger.addEventListener('mouseenter', () => {
        this.openMenu(menu, trigger);
      });

      // 鼠标离开关闭（延迟）
      trigger.addEventListener('mouseleave', () => {
        this.scheduleClose();
      });

      menu.addEventListener('mouseenter', () => {
        this.cancelClose();
      });

      menu.addEventListener('mouseleave', () => {
        this.scheduleClose();
      });

      // 键盘支持
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleMenu(menu, trigger);
        } else if (e.key === 'Escape') {
          this.closeAllMenus();
        }
      });

      // 点击触发（触摸屏）
      trigger.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          this.toggleMenu(menu, trigger);
        }
      });
    });

    // 点击外部关闭
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mega-menu-trigger]') && 
          !e.target.closest('[data-mega-menu]')) {
        this.closeAllMenus();
      }
    });

    // ESC 键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllMenus();
      }
    });

    // 窗口调整大小时关闭菜单
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          this.closeAllMenus();
        }
      }, 150);
    });
  }

  openMenu(menu, trigger) {
    this.cancelClose();
    
    // 关闭其他菜单
    if (this.activeMenu && this.activeMenu !== menu) {
      this.closeMenu(this.activeMenu);
    }

    menu.setAttribute('data-visible', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('active');
    
    this.activeMenu = menu;

    // 触发自定义事件
    menu.dispatchEvent(new CustomEvent('megamenu:open', {
      bubbles: true,
      detail: { trigger }
    }));
  }

  closeMenu(menu) {
    if (!menu) return;

    const trigger = document.querySelector(`[aria-controls="${menu.id}"]`);
    
    menu.setAttribute('data-visible', 'false');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('active');
    }

    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }

    // 触发自定义事件
    menu.dispatchEvent(new CustomEvent('megamenu:close', {
      bubbles: true,
      detail: { trigger }
    }));
  }

  closeAllMenus() {
    const allMenus = document.querySelectorAll('[data-mega-menu]');
    allMenus.forEach(menu => {
      this.closeMenu(menu);
    });
  }

  toggleMenu(menu, trigger) {
    const isVisible = menu.getAttribute('data-visible') === 'true';
    
    if (isVisible) {
      this.closeMenu(menu);
    } else {
      this.openMenu(menu, trigger);
    }
  }

  scheduleClose() {
    this.closeTimeout = setTimeout(() => {
      this.closeAllMenus();
    }, 300); // 300ms 延迟
  }

  cancelClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }
}

// 初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
  });
} else {
  new MegaMenu();
}

// 导出供外部使用
window.MegaMenu = MegaMenu;

